export interface FeatureFlagInfo {
  flagName: string;
}

export const FEATURE_FLAG_MAP = {
  SCHEDULER_V3_UI: {
    flagName: 'scheduler-v3-ui',
  },
  OPERATORY_V3: {
    flagName: 'schedule:operatory-v3',
  },

  SCHEDULE_WAITLIST_DIRECT_SCHEDULING: {
    flagName: 'schedule:waitlist:direct_scheduling',
  },
  NEW_APPOINTMENT_PANEL_UI: {
    flagName: 'schedule:new-appointment-panel-ui',
  },
  SCHEDULE_CALENDAR_BLOCK_UI: {
    flagName: 'schedule:calendar-block-ui',
  },
  SCHEDULE_CALENDAR_COLUMNS_REORDERING: {
    flagName: 'schedule-calendar-columns-reordering',
  },
  SCHEDULE_CALENDAR_APPOINTMENTS_REORDERING: {
    flagName: 'schedule:calendar-appointments-reordering',
  },
  SCHEDULE_CALENDAR_EXPAND_COLLAPSE: {
    flagName: 'schedule:calendar-expand-collapse',
  },
  SCHEDULE_REQUESTS_WIDGET: {
    flagName: 'schedule:requests-widget-v3',
  },
} as const satisfies Record<string, FeatureFlagInfo>;

export type FeatureFlagKey = keyof typeof FEATURE_FLAG_MAP;
